/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { HelpModalComponentArgs } from 'cio/components/help-modal';
import { isEmpty } from '@ember/utils';
import { inject as service } from '@ember/service';
import AnalyticsService from 'cio/services/analytics';

enum FormStages {
  Input = 'input',
  Thank = 'thank',
}

const formStagesMappings = {
  [FormStages.Input]: {
    text: "Can you tell us a little more about what you're trying to do and why?",
    buttonText: 'Send feedback',
  },
  [FormStages.Thank]: {
    text: "Your feedback was sent directly to our Product and Design team. We're grateful for your help in improving our product!",
    buttonText: 'Exit',
  },
};

export default class DataCampaignsFeedbackForm extends Component<HelpModalComponentArgs> {
  @service analytics!: AnalyticsService;
  @tracked suggestion = '';
  @tracked currentFormStage = FormStages.Input;

  get formStageLabels(): { text: string; buttonText: string; title: string } {
    let labels = formStagesMappings[this.currentFormStage];
    let title = this.getTitle();

    return { ...labels, title };
  }

  get submitDisabled(): boolean {
    return isEmpty(this.suggestion);
  }

  get headerIcon(): string {
    return this.isLastFormStage
      ? new URL('cio/assets/images/thanks.svg', import.meta.url).toString()
      : new URL('cio/assets/images/writing-feedback.svg', import.meta.url).toString();
  }

  get isInputStage(): boolean {
    return this.currentFormStage === FormStages.Input;
  }

  get isLastFormStage(): boolean {
    return this.currentFormStage === FormStages.Thank;
  }

  @action
  onInsert(): void {
    this.analytics.track('user', 'feedback_request_started', {
      source: 'Data Workflow - Trigger Tab',
    });
  }

  @action
  onButtonPress(): void {
    if (this.isLastFormStage) {
      this.args.onClose();
    }

    this.currentFormStage = FormStages.Input;
  }

  @action
  onSubmit(e: Event): void {
    e.preventDefault();

    this.args.onSubmit(
      {
        criticism:
          "We're working on improving campaign triggers page. Can you tell us a little more about what you're trying to do and why?",
        praise: this.suggestion,
      },
      true,
    );

    this.currentFormStage = FormStages.Thank;
  }

  private getTitle(): string {
    if (this.isLastFormStage) {
      return 'Thanks!';
    }
    return 'Share feedback';
  }
}
